<script>
import BigDiamonds from "@/components/BigDiamonds.vue";

export default {
  name: "AppCompetences",
  components: {BigDiamonds},
}
</script>

<template>
  <section id="competences">
    <BigDiamonds />
    <div class="wire-ctnC">
      <div class="wire1"></div>
      <div class="wire2"></div>
      <div class="wire3"></div>
    </div>
    <h3 class="slide-reveal">Compétences informatiques</h3>
    <div class="ctn-competences">
      <div class="line2">
        <div class="l2-div">
          <h4 class="slide-reveal">Systèmes d'exploitation</h4>
          <div class="cp-list slide-reveal">
            <div class="cp-tech">
              <img src="@/assets/images/logo/windows.png">
              <p>Windows</p>
            </div>
            <div class="cp-tech">
              <img src="@/assets/images/logo/linux.png">
              <p>Linux</p>
            </div>
          </div>
        </div>
        <div class="l2-div">
          <h4 class="slide-reveal">Outils & environnements</h4>
          <div class="cp-list slide-reveal">
            <div class="cp-tech">
              <img src="@/assets/images/logo/git.png">
              <p>Git (lab & hub)</p>
            </div>
            <div class="cp-tech">
              <img src="@/assets/images/logo/vscode.webp">
              <p>Visual Studio Code</p>
            </div>
            <div class="cp-tech">
              <img src="@/assets/images/logo/JetBrains.png">
              <p>Outils JetBrains</p>
            </div>
            <div class="cp-tech">
              <img src="@/assets/images/logo/android-studio.png">
              <p>Android Studio</p>
            </div>
          </div>
        </div>
      </div>
      <h3 class="slide-reveal">Technologies</h3>
      <div class="line3">
        <div class="l3-div">
          <h4 class="slide-reveal">Back-End</h4>
          <div class="cp-list">
            <div class="cp-tech slide-reveal">
              <img src="@/assets/images/logo/c.png">
              <p>C</p>
            </div>
            <div class="cp-tech slide-reveal">
              <img src="@/assets/images/logo/Csh.png">
              <p>C#</p>
            </div>
            <div class="cp-tech slide-reveal">
              <img src="@/assets/images/logo/python.png">
              <a><p>Python</p></a>
            </div>
            <div class="cp-tech slide-reveal">
              <img class="bg-white-bl" src="@/assets/images/logo/java.png">
              <p>Java</p>
            </div>
          </div>
        </div>
        <div class="l3-div">
          <h4 class="slide-reveal">Web</h4>
          <div class="cp-list">
            <div class="cp-tech slide-reveal">
              <img src="@/assets/images/logo/html.png">
              <p>HTML</p>
            </div>
            <div class="cp-tech slide-reveal">
              <img src="@/assets/images/logo/css.png">
              <p>CSS</p>
            </div>
            <div class="cp-tech slide-reveal">
              <img src="@/assets/images/logo/javascript.png">
              <p>JavaScript</p>
            </div>
            <div class="cp-tech slide-reveal">
              <img src="@/assets/images/logo/php.png">
              <a href="https://php.net" target="_blank"><p>PHP</p></a>
            </div>
            <div class="cp-tech slide-reveal">
              <img src="@/assets/images/logo/symfony.png">
              <a href="https://symfony.com/" target="_blank"><p>Symfony</p></a>
            </div>
            <div class="cp-tech slide-reveal">
              <img class="bg-white-bl" src="@/assets/images/logo/laravel.png">
              <a href="https://laravel.com/" target="_blank"><p>Laravel</p></a>
            </div>
            <div class="cp-tech slide-reveal">
              <img src="@/assets/images/logo/vue.png">
              <a href="https://vuejs.org/" target="_blank"><p>Vue js</p></a>
            </div>
            <div class="cp-tech slide-reveal">
              <img src="@/assets/images/logo/react.png">
              <a href="https://react.dev/" target="_blank"><p>React</p></a>
            </div>
            <div class="cp-tech slide-reveal">
              <img class="bg-white-bl" src="@/assets/images/logo/angular.png">
              <a href="https://angular.dev/" target="_blank"><p>Angular</p></a>
            </div>
            <div class="cp-tech slide-reveal">
              <img class="bg-white-bl" src="@/assets/images/logo/flask.png">
              <a href="https://flask.palletsprojects.com/en/stable/" target="_blank"><p>Flask</p></a>
            </div>
            <div class="cp-tech slide-reveal">
              <img src="@/assets/images/logo/gsap.png">
              <a href="https://gsap.com/" target="_blank"><p>GSAP</p></a>
            </div>
          </div>
        </div>
        <div class="l3-div">
          <h4 class="slide-reveal">Base de données</h4>
          <div class="cp-list">
            <div class="cp-tech slide-reveal">
              <img src="@/assets/images/logo/postgresql.png">
              <p>Postgre SQL</p>
            </div>
            <div class="cp-tech slide-reveal">
              <img src="@/assets/images/logo/mysql.png">
              <p>MySQL</p>
            </div>
            <div class="cp-tech slide-reveal">
              <img src="@/assets/images/logo/PhpMyAdmin.png">
              <p>PHPMyAdmin</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style>
  #competences {
    margin-top: 20vh;
    position: relative;
    overflow: hidden;
  }

  #competences h3{
    font-weight: 300;
    margin-top: 6vh;
    margin-bottom: 0;
  }

  #competences h4{
    font-weight: 280;
    margin-top: 6vh;
    margin-bottom: 3.2vh;
  }

  .wire-ctnC {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 50vw;
    height: 100vh;
    z-index: 0;
  }

  .wire-ctnC .wire1{
    position: absolute;
    opacity: 0.8;
    bottom: 10%;
    right: 0;
    width: 27%;
    height: 20%;
    border-bottom: solid #22527a 0.5vw;
    border-left: solid #22527a 0.5vw;
  }

  .wire-ctnC .wire2{
    position: absolute;
    opacity: 0.8;
    bottom: 15%;
    right: 0;
    width: 22%;
    height: 15%;
    border-bottom: solid #22527a 0.5vw;
    border-left: solid #22527a 0.5vw;
  }

  .wire-ctnC .wire3{
    position: absolute;
    opacity: 0.8;
    bottom: 30%;
    right: 20%;
    width: 10%;
    height: 2.5%;
    background-color: #22527a;
  }

  .line2, .line3{
    padding: 0 10vw 8vh 10vw;
    display: flex;
    gap: 2vw;
  }

  .l2-div {
    text-align: left;
    width: 50%;
  }

  .l3-div {
    text-align: left;
    width: 33.3%;
  }

  .cp-list{
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 1vh;
  }

  .cp-tech {
    margin-left: 2vw;
    font-size: 2em;
    display: flex;
    gap: 10px;
    align-items: center;
    white-space: nowrap;
  }

  .cp-tech img{
    width: 3.2vw;
    height: 3.2vw;
    object-fit: contain;
    border-radius: 4px;
  }

  .cp-tech a {
    text-decoration: none;
    font-weight: 340;
    color: white;
    transition: 0.3s font-weight, 0.3s margin-left;
  }

  .cp-tech a:hover {
    margin-left: 6px;
    font-weight: 460;
  }

  .bg-white-bl{
    background-color: white;
  }

  /* RESPONSIVE */
  @media (max-width: 480px) {
    #competences {
      margin-top: 4vh;
    }

    .line2, .line3 {
      /*padding: 0 6vw 8vh 6vw;*/
      flex-direction: column;
      align-items: center;
    }

    .l2-div, .l3-div {
      width: 100%;
      text-align: center;
    }

    #competences h3{
      font-weight: 400;
    }

    .ctn-competences h4{
      font-size: 6vw;
    }

    .cp-list{
      padding-left: 15vw;
    }

    .cp-tech p {
      font-size: 4.6vw;
    }
  }
</style>